<app-main-header *transloco="let t">{{t('delete-account')}}</app-main-header>
<app-delete-account></app-delete-account>
